export var BubbleAlignment;
(function (BubbleAlignment) {
    BubbleAlignment[BubbleAlignment["Left"] = 0] = "Left";
    BubbleAlignment[BubbleAlignment["Center"] = 1] = "Center";
    BubbleAlignment[BubbleAlignment["Right"] = 2] = "Right";
})(BubbleAlignment || (BubbleAlignment = {}));
export var BubbleShape;
(function (BubbleShape) {
    BubbleShape[BubbleShape["Circle"] = 0] = "Circle";
    BubbleShape[BubbleShape["Square"] = 1] = "Square";
    BubbleShape[BubbleShape["RightParallelogram"] = 2] = "RightParallelogram";
    BubbleShape[BubbleShape["LeftParallelogram"] = 3] = "LeftParallelogram";
    BubbleShape[BubbleShape["InvertedTrapezoid"] = 4] = "InvertedTrapezoid";
    BubbleShape[BubbleShape["ScaleneTrapezoid"] = 5] = "ScaleneTrapezoid";
})(BubbleShape || (BubbleShape = {}));
